import { useCallback, useMemo, memo } from "react";
import { Popup } from "@/components/popups/Popup";
import { Button } from "@/components/buttons/Button";
import { IAddToNichePopup } from "./types";
import { NicheSelector } from "@/components/niches/NicheSelector";
import "./AddToNichePopup.scss";

const ALLOWED_NICHES = 5;

export const AddToNichePopup: React.FC<IAddToNichePopup> = memo(({
  nicheFields,
  suggestNicheFields,
  myNichesLoading,
  gifSuggestedNichesLoading,
  onUpdateNiches,
  onClosePopup,
  onFollowNiche,
  onSubmit
}) => {
  const onSendData = useCallback(() => {
    const data = nicheFields.filter(option => option.isChecked)
      .map((option) => option.id);

    onSubmit(data);
  }, [nicheFields]);

  const buttonDisabled = useMemo(() => {
    const checkedCount = nicheFields.filter(niche => niche.isChecked).length;
    const defaultCheckedCount = nicheFields.filter(niche => niche.added).length;
    return nicheFields.length ? (checkedCount - defaultCheckedCount <= 0 || checkedCount > ALLOWED_NICHES) : true;
  }, [nicheFields]);

  return (
    <Popup
      title="Add Content to a Niche"
      isOpen={true}
      popupClass={"AddGifToNiche"}
      onClose={onClosePopup}
    >
      <NicheSelector
        theme="dark"
        nicheFields={nicheFields}
        suggestNicheFields={suggestNicheFields}
        myNichesLoading={myNichesLoading}
        gifSuggestedNichesLoading={gifSuggestedNichesLoading}
        onUpdateNiches={onUpdateNiches}
        onFollowNiche={onFollowNiche}
      />
      <div className="NicheBottom">
        <button className="NicheBottom-Cancel" onClick={onClosePopup}>Cancel</button>
        <Button onClick={onSendData} disabled={buttonDisabled}>Add to Niche</Button>
      </div>
    </Popup>
  );
});
